// rate limit is 50 requests per minute
export const WORKSPACE_UPLOAD_CONCURRENCY = 2;
export const WORKSPACE_UPLOAD_COOL_DOWN_MS = 1700;

export const WORKSPACE_EXPORT_CONCURRENCY = 3;
export const WORKSPACE_EXPORT_COOL_DOWN_MS = 0;
